import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import FormControl from "react-bootstrap/FormControl";
import React, { Component } from "react";
import "./connexion.css";
import CookieConsent from "react-cookie-consent";

import { Link } from "react-router-dom";

class Connexion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      message: "",
      isRevealPwd: false,
      confirmed: false,
      name: "",
    };
  }
  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });

  };
  addLogin = (e) => {
    e.preventDefault();
    const data = {
      email: this.state.email,
      password: this.state.password,
    };

    const headers = new Headers({
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "POST",
      body: JSON.stringify(data),
      headers: headers,
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/login", options)
      .then((response) => {
        return response.json();
      })

      .then((responseData) => {
        this.setState({ message: responseData.message });

        if (responseData.token) {
          localStorage.setItem("token", responseData.token);
          localStorage.setItem("compteId", responseData.compteId);
          // Liste des restaurants du compte + sélection du restaurant courant
          const restaurants = responseData.restaurants || [];
          localStorage.setItem("restaurants", JSON.stringify(restaurants));
          if (restaurants.length > 0) {
            localStorage.setItem("restaurantId", restaurants[0]._id);
            localStorage.setItem("restaurantPublicId", restaurants[0].publicId);
            localStorage.setItem(
              "restaurantName",
              restaurants[0].restaurantName
            );
          }
          this.props.setLogin(true);
          this.props.history.push("/homepage");
        }
      });
  };

  componentDidMount() {
    localStorage.clear();
    // Redirigé depuis le lien de confirmation d'inscription (?confirmed=1&name=...)
    const params = new URLSearchParams(window.location.search);
    if (params.get("confirmed") === "1") {
      this.setState({ confirmed: true, name: params.get("name") || "" });
    }
  }

  render() {
    return (
      <Container className="connexion-container">
        {this.state.confirmed ? (
          <div className="confirmBanner">
            {this.state.name ? (
              <span className="confirmName">Merci {this.state.name} !</span>
            ) : null}
            ✓ Votre compte a bien été confirmé. Vous pouvez maintenant vous
            connecter.
          </div>
        ) : null}
        {/* <CookieConsent
          location="bottom"
          buttonText="J'accepte"
          declineButtonText="Je refuse"
          expires={30}
          enableDeclineButton
          onDecline={() => {
            alert("REFUS de cookies, votre choix à bien été pris en compte.");
          }}
          cookieName="Tipourboire"
          style={{ background: "#ffffff", color: "#555" }}
          declineButtonStyle={{
            borderRadius: 12,
            padding: 8,
            color: "#fff",
            fontSize: "18px",
            background: "#f5a624",
            fontWeight: "bold",
          }}
          buttonStyle={{
            borderRadius: 12,
            padding: 8,
            color: "#fff",
            fontSize: "18px",
            background: "#f5a624",
            fontWeight: "bold",
          }}
          style={{
            fontSize: "10px",
            fontfamily: "Montserrat",
            fontWeight: "bold",
            zIndex: 2000,
          }}>
          Le Site Tipourboire utilise différents cookies afin d’améliorer ses
          services et effectuer des suivis d’audience. Certains cookies sont
          indispensables au fonctionnement du Site. Vous pouvez accepter ces
          cookies, les refuser, ou gérer vos préférences. Vous pouvez consulter
          notre{" "}
          <a
            href="/cookies/POLITIQUE_DE_COOKIES.pdf"
            target="_blank"
            style={{
              fontSize: "20px",
              fontfamily: "Montserrat",
              fontWeight: "bold",
            }}>
            Politique de cookies
          </a>
        </CookieConsent>*/}
        <Row>
          <Col>
            <h1>Déja inscrit ? </h1>
            <h1>Connectez-vous !</h1>
          </Col>
        </Row>
        <Form.Group controlId="formBasicEmail">
          <Form.Control
            name="email"
            type="email"
            ClassName="formMail"
            placeholder="Votre e-mail"
            id="email"
            onChange={this.handleInput}
            value={this.state.email}
          />
          <div className="pwd-container">
            <Form.Control
              type={this.state.isRevealPwd ? "text" : "password"}
              placeholder="Votre mot de passe"
              name="password"
              id="password"
              ClassName="formMail"
              onChange={this.handleInput}
              value={this.state.password}
            />
            {this.state.isRevealPwd ? (
              <a
                onClick={() => {
                  this.setState({ isRevealPwd: false });
                }}>
                <img src="/image/oeil.png" />
              </a>
            ) : (
              <a
                onClick={() => {
                  this.setState({ isRevealPwd: true });
                }}>
                <img src="/image/invisible.png" />
              </a>
            )}
          </div>
        </Form.Group>
        <Col className="colMdp" xs={12} md={12}>
          <Link className="forgetpwd" to="/passwordReset">
            <p>Mot de passe oublié ?</p>
          </Link>
        </Col>
        <Col md={12} className="blocCompte">
          <Button className="connectButton" onClick={this.addLogin}>
            Se connecter
          </Button>
          <p>{this.state.message}</p>
        </Col>
        <Col className="alignRight">
          <Form.Label className="text2">
            Pas encore inscrit ?{" "}
            <Link className="creerCompte" to="/Inscription">
              Créer mon compte
            </Link>
          </Form.Label>
        </Col>
      </Container>
    );
  }
}
export default Connexion;
